import React from 'react';

import classNames from 'classnames/bind';
import style from './Paragraph.scss';
const ctx = classNames.bind(style);

const Paragraph = props => (
  <div className={ctx('paragraph')}>{props.children}</div>
);

export default Paragraph;
